import { FormInstance, Rule } from "antd/lib/form"

import { checkMaxNumber, checkMinNumber } from "./utils.rules"

export const createCardFilterRules = (formInstance: FormInstance) => ({
    minLimit: [
        {
            validator: (_rule: unknown, value: number | string) => checkMinNumber({ formInstance, value, name: "maxLimit" }),
        },
    ] as Array<Rule>,
    maxLimit: [
        {
            validator: (_rule: unknown, value: number | string) => checkMaxNumber({ formInstance, value, name: "minLimit" }),
        },
    ] as Array<Rule>,
})
